import { FieldProps, Field as FormikField, FieldAttributes } from "formik";
import React, { FunctionComponent } from "react";

export const InputField: FunctionComponent<FieldAttributes<any>> = ({ ...props }) => {
  return (
    <FormikField {...props}>
      {({ field }: FieldProps) => {
        return <input {...field} value={field.value === undefined ? "" : field.value} {...props} />;
      }}
    </FormikField>
  );
};

InputField.displayName = "InputField";
